import React from "react";
import Box from "@mui/material/Box";

export interface EllipsisProps {
    lines?:
        | number
        | string
        | {
        xs?: number | string;
        sm?: number | string;
        md?: number | string;
        lg?: number | string;
        xl?: number | string;
    };

    wordBreak?: boolean;

    sx?: any;

    children?: any;
}

export const Ellipsis = ({
                             lines = 1,
                             wordBreak = false,
                             sx = {},
                             children,
                             ...props
                         }: EllipsisProps) => {

    const lineClamp =
        typeof lines === "object"
            ? Object.fromEntries(
                Object.entries(lines).map(
                    ([key, value]) => [
                        key,
                        String(value),
                    ]
                )
            )
            : String(lines);

    return (
        <Box
            {...props}
            sx={{
                width: "100%",

                overflow: "hidden",

                textOverflow: "ellipsis",

                display: "-webkit-box",

                WebkitBoxOrient: "vertical",

                WebkitLineClamp: lineClamp,

                ...(wordBreak && {
                    wordBreak: "break-all",
                }),

                ...sx,
            }}
        >
            {children}
        </Box>
    );
};

export default Ellipsis;